import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackBarTheme } from '../models/snackbar-theme.enum';
import { AccountService } from '../services/account/account.services';
import { TranslationConstants } from '../services/util/translation.constants';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ProductsBackend } from '../models/products.model';
import { UserLoggedModel } from '../models/user.logged.model';
import { OnkeypressService } from '../services/util/onkeypress.service';

@Component({
  selector: 'app-schedule-contact-modal',
  templateUrl: './schedule-contact-modal.component.html',
  styleUrls: ['./schedule-contact-modal.component.scss']
})
export class ScheduleContactModalComponent implements OnInit {

    public observation: string = '';
    public period: string = undefined;
    public contact: string = undefined;
    public loading: boolean;
    public contactForm: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.email]),
        name: new FormControl('', []),
    });

    constructor(
        public dialogRef: MatDialogRef<ScheduleContactModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { product: ProductsBackend, user: UserLoggedModel},
        private readonly accountService: AccountService,
        private readonly translationConstants: TranslationConstants,
        private readonly snackbarComponent: SnackbarComponent,
        private readonly keypressService: OnkeypressService // used in HTML
    ) { }

    public ngOnInit(): void {
        this.getUserLogged();
    }

    public close(): void {
        this.dialogRef.close();
    }

    public sendContact(): void {
        this.loading = true;
        this.accountService.sendNotification({
            name: this.contactForm?.value?.name,
            contact: this.contact,
            emailTo: this.contact,
            emailFrom: '',
            period: this.translationConstants.translate('scheduleContactDialog.' + this.period),
            observation: this.observation,
            product: this.data?.product?.name,
            storeId: this.data?.product?.store_id,
            subject: 'Contato - Kairos'
        }).subscribe(success => {
            this.snackbarComponent.openSnackBar(this.translationConstants.translate('scheduleContactDialog.success'), SnackBarTheme.success, 4000);
            setTimeout(() => {
                this.dialogRef.close()
            }, 2000);
        }).add(() => {
            this.loading = false;
        })
    }

    /**
     * To check if the user filled the Email or Number to contact and the period wished.
     */
    public checkToSend(): boolean {
        if (this.loading || (!this.contact || (!this.contactForm?.controls?.email || this.contactForm?.controls?.email?.invalid)) || !this.period) {
            return true;
        } else {
            return false;
        }
    }

    public getUserLogged(): void {
        if (this.data?.user) {
            this.contactForm.patchValue({name: this.data.user.name, email: this.data.user.email});
        }
    }

    public onKeyPressEvent(event: any){
        this.keypressService.onlyAllowNumbers(event, true, 15);
    }

}
